<template>
  <div class="card-container">
    <!-- downloadPower导出 -->
    <common-top-form
      selectShowPower="/posmanage/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      downloadPower="/posmanage/PeopleExport"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
      :needReset="true"
      @reset="reset"
      @openAddDialog="openAddDialog(1)"
      addShowPower="/posmanage/implementIssuedcz"
      buttonName="批量机具下发"
    >
      <el-form-item label="通道名称">
        <el-select v-model="formModel.chnCode">
          <el-option
            v-for="item in chnName"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 新增SN -->
      <el-form-item label="SN">
        <el-input v-model="formModel.sn" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="机具SN号">
        <el-input
          type="text"
          v-model.trim="formModel.snStart"
          placeholder="起始"
          style="width: 220px"
        ></el-input>
        <span>~</span>
        <el-input
          type="text"
          v-model.trim="formModel.snEnd"
          placeholder="结束"
          style="width: 220px"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户简称">
        <el-input v-model="formModel.merName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户编号">
        <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input
          v-model="formModel.agentPhone"
          maxlength="11"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="机具状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in Status"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="机具活动类型">
        <el-select v-model="formModel.machineActivityType">
          <el-option
            v-for="item in machineActivityTypeStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="硬件产品类型">
        <el-select v-model="formModel.hardwareType">
          <el-option
            v-for="item in hardwareTypeStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="兑换类型">
        <el-select v-model="formModel.exchangeType">
          <el-option
            v-for="item in exchangeType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="货源地">
        <el-select v-model="formModel.sourceArea">
          <el-option
            v-for="item in sourceArea"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下发日期">
        <el-date-picker
          v-model="formModel.sendDate"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="激活日期">
        <el-date-picker
          v-model="formModel.activeTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="机构名称"
        prop="activityName"
        v-if="this.textTatSimpleId"
      >
        <el-select style="width: 198px" v-model="formModel.tatSimpleId" filterable>
          <el-option
            v-for="item in typeTwo"
            :key="item"
            :label="item.tatName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
      <!-- <span>活动机具总计：未分配 {{ posStatistics.noSend || 0 }} 台</span
          ><span>已分配已激活：{{ posStatistics.hasActive || 0 }} 台</span
          ><span>已分配未激活：{{ posStatistics.hasSend || 0 }} 台</span> -->
    <div style="margin-bottom: 15px" v-if='this.textTatSimpleId'>
      <div>
        <div class="span" style="display: flex; align-items: center">
        
          <div>
            <el-button style="width: 100px" type="warning" @click="importEx(0)"
              >导入
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      @handleSelectionChange="handleSelectionChange"
    >
      <el-table-column
        prop="tatSimpleName"
        label="机构名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
      
        prop="chnName"
        min-width="180"
        label="通道名称"
        :formatter="formatterTableData"
      ></el-table-column>
        <el-table-column
      
        prop="chnCode2"
        min-width="180"
        label="子通道名称"
        :formatter="formatterTableData"
      ></el-table-column>
        <el-table-column
        prop='acqUid'
        min-width="120"
        label="当前通道"
        :formatter="formatterTableData"
      >
       <template slot-scope="scope">
         {{saveChooseShow(scope.row.acqUid)}}
        </template>
      </el-table-column>
       <el-table-column
        prop='acqUidTemp'
        min-width="120"
        label="目标通道"
        :formatter="formatterTableData"
      >
       <template slot-scope="scope">
         {{saveChooseShow(scope.row.acqUidTemp)}}
        </template>
      </el-table-column>
           <el-table-column
        prop='acqUidStatus'
        min-width="120"
        label="修改状态"
        :formatter="formatterTableData"
      >
       <template slot-scope="scope">
          {{
            scope.row.acqUidStatus == "1"
              ? "可修改"
              : scope.row.acqUidStatus == "2"
              ? "处理中"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="sn"
        min-width="300"
        label="SN"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merShorName"
        label="商户简称"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merNo"
        label="商户编号"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentNo"
        label="所属代理商ID"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentName"
        label="所属代理商姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentPhone"
        label="所属代理商手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="terminalNo"
        label="终端号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="machineStatus"
        label="机具状态"
        min-width="100"
        :formatter="formatterTablemachineStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hardwareType"
        label="硬件产品类型"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="bpName"
        label="业务产品名称"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="organization"
        label="所属组织"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="activeSubType"
        label="活动子类型"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="exchangeType"
        label="兑换类型"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sourceArea"
        label="货源地"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="导入日期"
        min-width="170"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sendDate"
        label="下发日期"
        min-width="170"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 新增 -->
      <el-table-column
        prop="simDate"
        label="收取日期"
        min-width="170"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="simNumber"
        label="第N次流量费"
        min-width="170"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
      
        prop="activeTime"
        label="激活日期"
        min-width="170"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="activityId"
        label="活动编号"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop='snUnBundling'
        min-width="120"
        label="是否解绑过"
        :formatter="formatterTableData"
      >
       <template slot-scope="scope">
          {{
            scope.row.snUnBundling == "0"
              ? "否"
              : scope.row.snUnBundling == "1"
              ? "是"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        min-width="380"
        v-if="
          hasPerm('/posmanage/bangding') ||
          hasPerm('/posmanage/implementIssued') ||
          hasPerm('/posmanage/upActivity')
        "
      >
        <template slot-scope="scope">
          <!-- <el-button
           
            type="text"
            @click="openAddDialogNew(scope.row)"
            
            >修改鼓励金
          </el-button> -->
          <el-button
            :disabled="scope.row.agentNo == null ? false : true"
            type="text"
            @click="openAddDialog(2, scope.row)"
            v-if="hasPerm('/posmanage/implementIssued')"
            >机具下发
          </el-button>
          <el-button
            type="text"
            @click="recoverycz(scope.row)"
            v-if="hasPerm('/posmanage/recovery')"
            >机具回收
          </el-button>
          <el-button
            type="text"
            @click="openAddDialog(3, scope.row)"
            v-if="hasPerm('/posmanage/upstatus')"
            >修改
          </el-button>
            <el-button
            type="text"
            @click="upgrade(scope.row)"
           v-if="scope.row.chnName == 'FJMF'"
            >
            升级燎原
          </el-button>
          <el-button
            type="text"
            @click="inquireChannel(scope.row)"
            v-if="scope.row.chnName == 'YSBBIG'"
            >查询上游通道
          </el-button>
          <el-button
            type="text"
            @click="handleUnbind(scope.row)"
            v-if="scope.row.chnName == 'ZNP' || scope.row.chnName == 'YSBBIG'"
            >机具解绑
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="getFormDialogTitle(dialogType)"
      :model="dialogModel"
      :submitData="dialogData"
  :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="dialog"
      :show="dialogType != 0 && dialogType != 9"
      dialogWidth="780px"
    >
  
      <!-- 0是否显示导入组件 标记位0-->
      <div
        class="flex-row vertical-center flow-center"
        v-if="dialogType == 0 || dialogType == 9"
      >
        <el-form-item label="通道名称" prop="chnCode">
          <el-select v-model="dialogModel.chnCode">
            <el-option
              v-for="item in chnName.slice(1, chnName.length)"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-upload
          ref="upload"
          class="upload-demo"
          accept=".xlsx"
          name="file"
          :action="uploadUrl + '8885/machines/t-machines/importMachines'"
          :data="commonParams"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :show-file-list="false"
          :limit="1"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
      <!-- 是否显示批量机具下发 标记位1、机具下发组件 标记位2-->
      <div v-if="dialogType == 1 || dialogType == 2">
        <el-form-item label="代理商ID" prop="userPhone" label-width="110px">
          <el-input
            type="text"
            v-model="dialogModel.userPhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="flex-row vertical-center mem-name">
          <p>代理商名称：</p>
          <p v-if="memName.phoneNumber">
            {{
              memName.realName ||
              memName.nickName ||
              "用户" + memName.phoneNumber
            }}
          </p>
        </div>
        <div v-if="dialogType == 1">
          <el-form-item
            label="机具SN号"
            label-width="110px"
            :prop="dialogModel.snStart ? 'snEnd' : 'snStart'"
          >
            <el-input
              type="text"
              v-model.trim="dialogModel.snStart"
              placeholder="起始"
              style="width: 203.33px"
            ></el-input>
            <span>~</span>
            <el-input
              type="text"
              v-model.trim="dialogModel.snEnd"
              placeholder="结束"
              style="width: 203.33px"
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-search"
              circle
              @click="posSnAll()"
            ></el-button>
          </el-form-item>
          <el-form-item
            class="sninput"
            label="可下发机具"
            prop="SnAmount"
            label-width="110px"
          >
            <el-input
              style="width: 203.33px"
              disabled
              type="text"
              v-model="dialogModel.SnAmount"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label-width="110px" label="兑换类型" prop="exchangeType">
          <el-select style="width: 203px" v-model="dialogModel.exchangeType">
            <el-option
              v-for="item in exchangeType.slice(1, exchangeType.length)"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        
          <el-form-item
            label="活动编号"
            label-width="110px"
         
          >
            <el-input
              type="text"
              v-model="dialogModel.id"
              placeholder="请输入活动编号"
              style="width: 203.33px"
            ></el-input>
           
            <el-button
              type="primary"
              icon="el-icon-search"
              circle
              @click="signActivity()"
            ></el-button>
          </el-form-item>
        
      
       
   
         
        
        <!-- 新增活动类型 -->
        <el-form-item label="活动" label-width="110px" prop="activityId">
          <el-select style="width: 203px" v-model="dialogModel.activityId" filterable>
            <el-option
              v-for="item in type"
              :key="item"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="110px" label="备注">
          <el-input
            maxlength="300"
            show-word-limit
            type="textarea"
            resize="none"
            rows="5"
            placeholder="请输入备注"
            v-model="dialogModel.remark"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 是否显示修改状态组件 标记位3 -->
      <div v-if="dialogType == 3">
        <el-form-item label-width="110px" label="机具状态" prop="machineStatus">
          <el-select clearable v-model="dialogModel.machineStatus">
            <el-option
              v-for="item in Status.slice(1, Status.length)"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label-width="110px"
          label="硬件产品类型"
          prop="hardwareType"
        >
          <el-select clearable v-model="dialogModel.hardwareType">
            <el-option
              v-for="item in hardwareTypeStatus.slice(
                1,
                hardwareTypeStatus.length
              )"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </form-dialog>
    <!-- 新增弹窗 -->
    <form-dialog
      ref="formDialogNew"
      :formDialogTitle="'修改鼓励金'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="dialog"
      dialogWidth="780px"
    >
      <!-- 0是否显示导入组件 标记位0-->

      <el-form-item label-width="110px" label="活动类型" prop="exchangeType">
        <el-select style="width: 203px" v-model="dialogModel.exchangeType">
          <el-option
            v-for="item in exchangeType.slice(1, exchangeType.length)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </form-dialog>
    <!-- 新增查询上游通道 -->
      <show-info-dialog
      title="上游通道"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>上游通道：{{  dialogObj || '' }}</p>
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import FinanceService from "service/FinanceService";
import PosService from "service/PosService";
import StatisticsService from "service/StatisticsService";
import Server from "common/conf/Server";
import Regs from "common/conf/Regs";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import activity from "service/Ainstitution";

export default {
  name: "posmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog
  },
  data() {
    var validateStart = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入"));
      } else {
        callback();
      }
    };
    var validateEnd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入"));
      } else {
        callback();
      }
    };
    return {
      saveChoose:[],
   
      type: [],
      uploadUrl: Server[process.env.NODE_ENV],
      dialogType: "",
      posStatistics: "",
      multipleSelection: "",
      machineId: "", //数据id
      memId: "",
      memName: {},
      formModel: {
        snStart: "",
        snEnd: "",
        hardwareType: "",
        machineActivityType: "",
        organization: "",
        exchangeType: "",
        sourceArea: "",
        status: "",
        sendDate: "",
        activeTime: "",
        merName: "",
        merNo: "",
        userId: "",
        agentPhone: "",
        chnCode: "",
        activeSubType: "",
        sn: "",
        tatSimpleId: "",
        id: ''
      },
      submitService: PosService.posmanageList,
      tableData: [],
      dialogModel: {
        snStart: "",
        snEnd: "",

        SnAmount: "",

        exchangeType: "",

        machineStatus: "",
        hardwareType: "",

        chnCode: "",

        remark: "",
        activityId: "",
        id: ''
      },
      dialogObj: '',
      dialogModelNew: {},
      isPage: false,
      page: {},
      moneyList: [],
      typeTwo: [{ tatName: "全部", id: "" }],
      hardwareTypeStatus: [{ id: "", name: "全部" }],
      machineActivityTypeStatus: [{ id: "", name: "全部" }],
      organizationStatus: [{ id: "", name: "全部" }],
      exchangeType: [{ id: "", name: "全部" }],
      sourceArea: [{ id: "", name: "全部" }],
      activeSubType: [{ dictKey: "", dictValue: "全部" }],
      chnName: [{ dictKey: "", dictValue: "全部" }],
      Status: [
        {
          key: "",
          value: "全部",
        },
      ],
      dialogRules: {
        userPhone: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else if (!/^\d+$/.test(value)) {
                callback(new Error("请输入纯数字"));
              } else {
                this.getRealNameByPhone(value, (res) => {
                  if (res.respCode == "0000") {
                    this.memName = res.contents;
                    this.memId = res.contents.id;
                    if (!this.memName.id) {
                      callback(new Error("查询不到此用户"));
                      this.memName = "";
                      this.memId = "";
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("查询不到此用户"));
                    this.memName = "";
                    this.memId = "";
                  }
                });
              }
            },
          },
        ],
        snStart: [
          { required: true, message: "请输入" },
          { validator: validateStart },
        ],
        snEnd: [
          { required: true, message: "请输入" },
          { validator: validateEnd },
        ],
        SnAmount: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    "可下发数量为0台,请核对好你要下发的机具号范围再次保存"
                  )
                );
              } else {
                callback();
              }
            },
          },
        ],
        activityId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        exchangeType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        machineStatus: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        hardwareType: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
      },
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    commonParams() {
      return {
        chnCode: this.dialogModel.chnCode,
        userId: this.userId,
      };
    },
    submitData() {
      if (this.formModel.sendDate == null || this.formModel.sendDate == "") {
        this.formModel.sendDate = [];
      }
      if (
        this.formModel.activeTime == null ||
        this.formModel.activeTime == ""
      ) {
        this.formModel.activeTime = [];
      }
      this.params = {
        bossFlag: 1,
        snStart: this.formModel.snStart,
        snEnd: this.formModel.snEnd,
        hardwareType: this.formModel.hardwareType,
        machineActivityType: this.formModel.machineActivityType,
        organization: this.formModel.organization,
        exchangeType: this.formModel.exchangeType,
        sourceArea: this.formModel.sourceArea,
        status: this.formModel.status,
        merName: this.formModel.merName,
        merNo: this.formModel.merNo,
        userId: this.formModel.userId,
        agentPhone: this.formModel.agentPhone,
        chnCode: this.formModel.chnCode,
        activeSubType: this.formModel.activeSubType,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        sn: this.formModel.sn,
      };
      if (this.textTatSimpleId) {
        this.params.tatSimpleId = this.formModel.tatSimpleId;
      }
      if (this.formModel.sendDate.length) {
        this.params.sendDateStart = this.formModel.sendDate[0];
        this.params.sendDateEnd = this.formModel.sendDate[1];
      }
      if (this.formModel.activeTime.length) {
        this.params.activeTimeStart = this.formModel.activeTime[0];
        this.params.activeTimeEnd = this.formModel.activeTime[1];
      }
      return this.params;
    },
    dialogData() {
      const params = {
        //机具下发
        machineId: this.machineId,
        userId: this.memId,
        exchangeType: this.dialogModel.exchangeType,
        remark: this.dialogModel.remark,
        activityId: this.dialogModel.activityId,
      };
      switch (this.dialogType) {
        case 1: //批量机具下发
          delete params.machineId;
          params.snStart = this.dialogModel.snStart;
          params.snEnd = this.dialogModel.snEnd;
          break;
        case 3: //修改状态
          delete params.machineId;
          delete params.userId;
          delete params.exchangeType;
          delete params.remark;
          params.status = this.dialogModel.machineStatus;
          params.hardwareType = this.dialogModel.hardwareType;
          params.id = this.machineId;
          break;
      }
      return params;
    },
    dialogService() {
      switch (this.dialogType) {
        case 1:
          // 批量机具下发
          return PosService.posimplementIssuedczpl;
        case 2:
          // 机具下发
          return PosService.posimplementIssuedcz;
        case 3:
          // 修改状态
          return PosService.posimplementupstatus;
        default:
          return null;
      }
    },
    ...mapGetters(["serverType", "tatId", "userId", "textTatSimpleId"]),
  },
  mounted() {
    this.load();
    this.getType();
    this.getTypeNames("活动子类型", (res) => {
      this.activeSubType = res;
    });
    this.getTypeNames("chnName", (res) => {
      this.chnName = [...this.chnName, ...res];
    });
     this.getTypeNames("上游渠道号", (res) => {
      this.saveChoose = res
    });

  },
  
  watch: {
    "dialogModel.snStart"(val, oldVal) {
      if (!val) {
        return (this.dialogModel.SnAmount = "");
      }
    },
    "dialogModel.snEnd"(val, oldVal) {
      if (!val) {
        return (this.dialogModel.SnAmount = "");
      }
    },
    "dialogModel.machineStatus"(val, oldVal) {
      const timeoutId = setTimeout(() => {
        this.$refs.formDialog.validateField("machineStatus");
      }, 200);
    },
    "dialogModel.hardwareType"(val, oldVal) {
      const timeoutId = setTimeout(() => {
        this.$refs.formDialog.validateField("hardwareType");
      }, 200);
    },
    dialogType(newVal, oldVal) {
      if (newVal === 3) {
        const timeoutId = setTimeout(() => {
          this.$refs.formDialog.validateField("machineStatus");
          this.$refs.formDialog.validateField("hardwareType");
        }, 200);
      }
    },
  },
  methods: {
    // 查询上游通道
    inquireChannel(e) {
       this.dialogObj = ''
       this.doLoad(
        PosService.Inquire,
        {
          
          sn: e.sn
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res)
             const result  = JSON.parse(res.contents)
             console.log(result)
              result.forEach(item => {
               this.dialogObj += item.channelName
             })
           
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    handleUnbind(row){
      this.$confirm('请注意：解绑操作只能清除本系统商户数据，不能同步清除上游商户信息，如需同步上游解绑，请联系客户H5操作解绑即可（PS：此功能针对：直接联系上游解绑机具，但是本系统数据没有清除，需要清除系统商户信息），是否确认操作？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          PosService.snUnBundlingBD({id:row.id}).then(res => { 
            this.$message({
              type: 'success',
              message: '解绑成功!'
            });
          })
        }).catch(() => {       
        });
    },
   saveChooseShow(e) {
    console.log(e, 'this.saveChoose');
    const foundItem = this.saveChoose.find(item => item.dictKey === e);
    return foundItem ? foundItem.dictValue : '--'; // 如果找到，返回 dictValue，否则返回空字符串
},
    getTypeTwo() {
      this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows, "res1");
            res.contents.rows.forEach((item) => {
              (item.dictValue = item.id), (item.dictKey = item.tatName);
            });
            this.typeTwo = [...this.typeTwo, ...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    // 查询
    signActivity() {
      console.log('CHW')
        this.doLoad(
        activity.signActivityList,
        {
          size: 9999,
          id: this.dialogModel.id
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows, "res");
            res.contents.rows.forEach((item) => {
              item.dictValue = item.name;
            });
            this.type = res.contents.rows;
          });
        },
        "信息获取失败"
      );
    },
    getType() {
      this.doLoad(
        activity.signActivityList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows, "res");
            res.contents.rows.forEach((item) => {
              item.dictValue = item.name;
            });
            this.type = res.contents.rows;
          });
        },
        "信息获取失败"
      );
    },
    getFormDialogTitle(dialogType) {
      switch (dialogType) {
        case 0:
          return "导入";
        case 1:
          return "批量机具下发";
        case 2:
          return "机具下发";
        case 3:
          return "修改状态";
        case 9:
          return "货源地更新";
        default:
          return "";
      }
    },
    load() {
      this.formModel = {
        hardwareType: "",
        machineActivityType: "",
        organization: "",
        exchangeType: "",
        sourceArea: "",
        status: "",
        sendDate: "",
        activeTime: "",
        chnCode: "",
        activeSubType: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getmachineActivityTypeStatus();
      this.gethardwareTypeStatus();
      this.getorganizationStatus();
      this.getposStatistics();
      this.getexchangeType();
      this.getsourceArea();
      this.getstatus();
      this.getMoneyList();
      this.getTypeTwo();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
    openAddDialog(type, item) {
      //批量机具下发弹框状态"1"  机具下发弹框状态为"2"  修改状态状态为"3"
      this.dialogType = type;
      if (type == 1) {
        // console.log(this.machineId);
      } else {
        this.dialogModel.machineStatus = item.machineStatus;
        this.dialogModel.hardwareType = item.hardwareType;
        this.machineId = item.id;
      }
      this.$refs.formDialog.open();
    },
    openAddDialogNew(item) {
      this.$refs.formDialogNew.open();
    },
    dialogClose() {
      if (this.dialogType == 0 || this.dialogType == 9) {
        this.$refs.upload.clearFiles();
      }

      this.dialogModel = {
        snStart: "",
        snEnd: "",

        SnAmount: "",

        exchangeType: "",

        machineStatus: "",
        hardwareType: "",

        chnCode: "",

        remark: "",
      };
      this.machineId = "";
      this.memId = "";
      this.memName = {};
      this.dialogType = "";
    },
    reset() {
      this.formModel = {
        sn: "",
        hardwareType: "",
        machineActivityType: "",
        organization: "",
        exchangeType: "",
        sourceArea: "",
        status: "",
        remark: "",
        sendDate: "",
        activeTime: "",
        merName: "",
        merNo: "",
        userId: "",
        agentPhone: "",
        chnCode: "",
        activeSubType: "",
      };
    },
    beforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg == "xls";
      const extension2 = testmsg == "xlsx";
      const limitSize = file.size != 0;
      const chnCode = this.dialogModel.chnCode;
      if ((!extension && !extension2 && !limitSize) || !chnCode) {
        this.$refs.upload.clearFiles();
        this.$message.warning(
          "上传文件只能是 xls、xlsx格式、文件不能为空 或 通道名称不能为空"
        );
        return false;
      }
      return extension || extension2 || limitSize;
    },
    handleSuccess(res) {
      this.hideLoading();
      if (
        "0000" != res.respCode ||
        (res.contents &&
          res.contents.optStatus &&
          "0000" != res.contents.optStatus)
      ) {
        this.$refs.upload.clearFiles();
        return this.showError(
          res.respMsg ||
            res.respCode + ":未知错误" ||
            res.contents.optMsg ||
            res.contents.optStatus + ":未知错误"
        );
      } else {
        this.$refs.formDialog.closeDialog();
        this.getList();
        this.getposStatistics();
        this.showSuccess(res.respMsg);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let str = "";
      this.multipleSelection.forEach(function (item, index) {
        str += item.id + ",";
      });
      str = str.substring(0, str.length - 1);
      // this.machineId = str.split(",");
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "exportMachines",
            "8885",
            "/machines/t-machines/"
          )
        : "";
    },
    importEx(type) {
      //导入弹框状态"0"
      this.dialogType = type;
      this.$refs.formDialog.open();
    },
    getmachineActivityTypeStatus() {
      //机具活动类型
      this.doLoad(
        PosService.posJiJuType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.machineActivityTypeStatus = [
              ...this.machineActivityTypeStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    gethardwareTypeStatus() {
      //硬件产品类型
      this.doLoad(
        PosService.posYingJianType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareTypeStatus = [
              ...this.hardwareTypeStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    getorganizationStatus() {
      //所属组织
      this.doLoad(
        PosService.posSuoShuType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.organizationStatus = [
              ...this.organizationStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    getexchangeType() {
      //兑换类型
      this.doLoad(
        PosService.posexchangeType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.exchangeType = [...this.exchangeType, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getMoneyList() {
      this.doLoad(
        activity.moneyList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.moneyList = [...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getsourceArea() {
      //货源地
      this.doLoad(
        PosService.possourceArea,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.sourceArea = [...this.sourceArea, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getposStatistics() {
      //机具统计
      this.doLoad(
        PosService.posStatistics,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.posStatistics = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    getstatus() {
      //机具状态
      this.doLoad(
        PosService.status,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.Status = [...this.Status, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getRealNameByPhone(val, onSuccess) {
      const params = {
        tatSimpleId: this.tatId,
        userId: val,
      };
      this.doLoad(
        FinanceService.getRealNameByPhone,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    posSnAll() {
      if (!this.dialogModel.snStart || !this.dialogModel.snEnd) {
        this.$refs.formDialog.validateField("snStart");
        this.$refs.formDialog.validateField("snEnd");
      } else {
        const params = {
          snStart: this.dialogModel.snStart,
          snEnd: this.dialogModel.snEnd,
        };
        this.doLoad(
          PosService.getposSnAll,
          params,
          (res) => {
            this.doCheck(res, (res) => {
              this.dialogModel.SnAmount = res.contents;
            });
          },
          "信息获取失败"
        );
      }
    },
    recoverycz(row) {
      this.showConfirm("是否回收机具？")
        .then(() => {
          const params = {
            machineId: row.id,
          };
          this.doLoad(
            PosService.recoverycz,
            params,
            (res) => {
              this.doCheck(res, (res) => {
                this.showSuccess(res.respMsg);
                this.getList();
              });
            },
            "信息获取失败"
          );
        })
        .catch(() => {});
    },
      upgrade(row) {
      this.showConfirm("是否升级？")
        .then(() => {
          const params = {
            id: row.id,
          };
          this.doLoad(
            PosService.Promotion,
            params,
            (res) => {
              this.doCheck(res, (res) => {
                this.showSuccess(res.respMsg);
                this.getList();
              });
            },
            "信息获取失败"
          );
        })
        .catch(() => {});
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.getposStatistics();
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    dialogSuccess(res) {
      console.log(res,'res')
      if (this.dialogType == 0) {
        this.$refs.upload.submit();
      }
      this.showSuccess(res.respMsg);
      // this.$refs.formDialog.closeDialog();
      this.getList();
      this.getposStatistics();
    },
    formatterTablemachineStatus(row, column, cellValue, index) {
      let value = "";
      this.Status.forEach((item) => {
        if (item.key == cellValue) {
          value = item.value;
        }
      });
      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
.span span {
  font-size: 20px;
  margin-right: 15px;
  display: block;
}
.el-form-item >>> .el-form-item__error {
  width: 410px;
}

p {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin-bottom: 30px;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 106px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.sninput >>> .el-input__inner {
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/PosImplement/PosManage.vue